;(function () {
    function CountryFilter() {
        /**
         * local object availability
         * @type {CountryFilter}
         * @private
         */
        var _this = this

        /**
         * Contains all filters activated by the user
         * @type {*[]}
         */
        this.activeFilters = []

        /**
         * The callback function to be called whenever a filter is activated
         */
        this.selectionCallback

        /**
         * Button opening and closing the checkbox selection
         * @type {string}
         */
        this.countrySelectButton = '[data-expert-type="dynamic-map-select-button"]'

        /**
         * Wrapper of the filter checkboxes
         * @type {string}
         */
        this.countrySelectCheckboxes = '[data-expert-type="dynamic-map-checkboxes"]'

        /**
         * The countries that have already been added as a filter option
         * @type {*[]}
         */
        this.knownCountries = []

        /**
         * Holds the information if the button for displaying the country selection checkboxes been initialized already
         * @type {boolean}
         */
        this.isSelectCountryButtonActive = false

        this.init = function (data, callback) {
            _this.renderCountrySelection(data)
            _this.selectionCallback = callback
        }

        /**
         * Adds a change listener for a single checkbox
         * Whenever a filter is activated the array of the active filters is edited accordingly
         * Then the callback function (selected when initializing) is executed
         * @param checkboxSelector
         */
        this.initSelectCheckbox = function (checkboxSelector) {
            $(checkboxSelector).change(function () {
                var currentCountryFilter = $(this).val()
                _this.toggleCountryFilter(currentCountryFilter)
                _this.selectionCallback()
            })
        }

        /**
         * Adds or removes the given filter
         */
        this.toggleCountryFilter = function (currentCountryFilter) {
            index = _this.activeFilters.indexOf(currentCountryFilter)
            if (index >= 0) {
                _this.activeFilters.splice(index, 1)
            } else {
                _this.activeFilters.push(currentCountryFilter)
            }
        }

        /**
         * Adds the country options depending on the visible markers
         * @param data
         */
        this.renderCountrySelection = function (data) {
            availableCountries = _this.getAvailableCountries(data)

            if (availableCountries.length > 1) {
                _this.addCountryFilterOptions(availableCountries)

                if (!_this.isSelectCountryButtonActive) {
                    _this.initializeSelectCountryButton()
                }
            }
            isCountrySelectionRendered = true
        }

        /**
         * Initialize the button opening the country selection
         */
        this.initializeSelectCountryButton = function () {
            $(_this.countrySelectButton).click(function (event) {
                // Prevents opening button from triggering the closing of the box
                event.stopPropagation()
                $(_this.countrySelectCheckboxes).show()
                _this.initCloseSelectionListener()
            })

            // Button is not displayed by default,
            // so it is not visible if the data does not contain countries
            $(_this.countrySelectButton).show()

            // make sure the button is only initialized once
            _this.isSelectCountryButtonActive = true
        }

        /**
         * Adds a new option for each of the available options if it hasn't been added before
         * @param availableCountries
         */
        this.addCountryFilterOptions = function (availableCountries) {
            availableCountries.forEach(function (country) {
                if (!_this.knownCountries.includes(country)) {
                    var customDiv = $('<div/>', { class: 'dynamic-map-checkbox-option' })
                    $('<input />', { type: 'checkbox', id: 'cb' + country, value: country }).appendTo(customDiv)
                    $('<label />', { for: 'cb' + country, text: country }).appendTo(customDiv)
                    customDiv.appendTo(_this.countrySelectCheckboxes)

                    // Activate the listener for the checkbox
                    _this.initSelectCheckbox('#cb' + country)

                    // add to the array of already initialized filters
                    _this.knownCountries.push(country)
                }
            })
        }

        /**
         * Extracts all unique countries from the given marker data
         * @param data
         * @returns {[]}
         */
        this.getAvailableCountries = function (data) {
            availableCountries = []

            availableCountries = data.reduce(function (availableCountries, accumulator) {
                if (availableCountries.indexOf(accumulator['country']) < 0) {
                    availableCountries.push(accumulator['country'].trim())
                }
                return availableCountries
            }, [])

            return availableCountries
        }

        /**
         * Closes the country selection if the x-button or anything outside the box is clicked
         */
        this.initCloseSelectionListener = function () {
            $(document).one('click', function (event) {
                if (
                    $(event.target).parents('[data-expert-type="dynamic-map-checkboxes"]').length < 1 ||
                    ($(event.target).data('expertType') !== undefined &&
                        $(event.target).data('expertType') === 'dynamic-map-select-close')
                ) {
                    $(_this.countrySelectCheckboxes).hide()
                } else {
                    _this.initCloseSelectionListener()
                }
            })
        }

        /**
         * Returns all activated filters
         * @returns {*}
         */
        this.getActiveFilters = function () {
            return _this.activeFilters
        }
    }

    window.CreatonExperts = window.CreatonExperts || {}

    window.CreatonExperts.CountryFilter = CountryFilter
})()
